var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmokeHeat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 75,
    viewBox: "0 0 72 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.625 29.7188V36.2812C65.625 53.1906 51.9094 66.9062 35 66.9062C18.0906 66.9062 4.375 53.1906 4.375 36.2812V29.7188C4.375 46.6281 18.0906 60.3438 35 60.3438C51.9094 60.3438 65.625 46.6281 65.625 29.7188Z",
    fill: "#CCD1D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M35 12.8438C47.0641 12.8438 56.875 22.6438 56.875 34.7188C56.875 46.7828 47.0641 56.5938 35 56.5938C22.9359 56.5938 13.125 46.7828 13.125 34.7188C13.125 22.6438 22.9359 12.8438 35 12.8438ZM48.125 34.7188C48.125 27.4781 42.2406 21.5938 35 21.5938C27.7594 21.5938 21.875 27.4781 21.875 34.7188C21.875 41.9594 27.7594 47.8438 35 47.8438C42.2406 47.8438 48.125 41.9594 48.125 34.7188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.25 35.125C66.25 52.3104 52.3104 66.25 35.125 66.25C17.9396 66.25 4 52.3104 4 35.125C4 17.9396 17.9396 4 35.125 4C52.3104 4 66.25 17.9396 66.25 35.125ZM57.3571 35.125C57.3571 22.8529 47.386 12.8929 35.125 12.8929C22.864 12.8929 12.8929 22.8529 12.8929 35.125C12.8929 47.386 22.864 57.3571 35.125 57.3571C47.386 57.3571 57.3571 47.386 57.3571 35.125Z",
    fill: "#E6E9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.125 26C40.1583 26 44.25 30.0917 44.25 35.125C44.25 40.1583 40.1583 44.25 35.125 44.25C30.0917 44.25 26 40.1583 26 35.125C26 30.0917 30.0917 26 35.125 26Z",
    fill: "#E6E9ED",
    stroke: "#E6E9ED",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4257 20.3762C27.7898 19.5689 29.2751 18.9455 30.8474 18.5401L31.097 19.5085C32.3838 19.1767 33.7334 19 35.125 19C36.5166 19 37.8662 19.1767 39.153 19.5085L39.4026 18.5401C40.9749 18.9455 42.4602 19.5689 43.8243 20.3762L43.315 21.2368C45.6602 22.6246 47.6254 24.5898 49.0132 26.935L49.8738 26.4257C50.6811 27.7898 51.3045 29.2751 51.7099 30.8474L50.7415 31.097C51.0733 32.3838 51.25 33.7334 51.25 35.125C51.25 36.5166 51.0733 37.8662 50.7415 39.153L51.7099 39.4026C51.3045 40.9749 50.6811 42.4602 49.8738 43.8243L49.0133 43.315C47.6254 45.6602 45.6602 47.6254 43.315 49.0132L43.8243 49.8738C42.4602 50.6811 40.9749 51.3045 39.4026 51.7099L39.153 50.7415C37.8662 51.0733 36.5166 51.25 35.125 51.25C33.7334 51.25 32.3838 51.0733 31.097 50.7415L30.8474 51.7099C29.2751 51.3045 27.7898 50.6811 26.4257 49.8738L26.935 49.0133C24.5898 47.6254 22.6246 45.6602 21.2368 43.315L20.3762 43.8243C19.5689 42.4602 18.9455 40.9749 18.5401 39.4026L19.5085 39.153C19.1767 37.8662 19 36.5166 19 35.125C19 33.7334 19.1767 32.3838 19.5085 31.097L18.5401 30.8474C18.9455 29.2751 19.5689 27.7898 20.3762 26.4257L21.2368 26.935C22.6246 24.5898 24.5898 22.6246 26.935 21.2368L26.4257 20.3762Z",
    stroke: "#E6E9ED",
    strokeWidth: 2,
    strokeDasharray: "9 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4373 62.8728C34.6099 62.8728 33.9336 62.2023 33.9336 61.3728C33.9336 60.5433 34.5949 59.8728 35.4209 59.8728H35.4373C36.2633 59.8728 36.9336 60.5433 36.9336 61.3728C36.9336 62.2023 36.2633 62.8728 35.4373 62.8728Z",
    fill: "#ED5565"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5007 51.7097V35.885C59.5007 33.7393 57.7612 32 55.6157 32C53.47 32 51.7307 33.7393 51.7307 35.885V51.7097C49.9924 52.9326 48.8567 54.9541 48.8567 57.241C48.8567 60.9739 51.8828 64 55.6157 64C59.3486 64 62.3748 60.9739 62.3748 57.241C62.3748 54.9541 61.2388 52.9326 59.5007 51.7097Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6157 61.7864C53.0417 61.7864 50.9478 59.6921 50.9478 57.1184C50.9478 55.1638 52.1624 53.4236 53.9849 52.7446V35.885C53.9849 34.9856 54.7163 34.2542 55.6157 34.2542C56.5149 34.2542 57.2466 34.9856 57.2466 35.885V52.7446C59.0688 53.4233 60.2837 55.1636 60.2837 57.1182C60.2837 59.6921 58.1897 61.7864 55.6157 61.7864Z",
    fill: "#F3E8D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9849 38.8669V52.7446C52.1624 53.4233 50.9478 55.1636 50.9478 57.1182C50.9478 59.6921 53.0417 61.7861 55.6157 61.7861C58.1897 61.7861 60.2837 59.6921 60.2837 57.1182C60.2837 55.1636 59.0688 53.4233 57.2466 52.7446V38.8669H53.9849Z",
    fill: "#FCDC36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8816 43.2637H62.0801C61.8132 43.2637 61.5972 43.0474 61.5972 42.7808C61.5972 42.5142 61.8132 42.2979 62.0801 42.2979H64.8816C65.1482 42.2979 65.3645 42.5142 65.3645 42.7808C65.3645 43.0474 65.1482 43.2637 64.8816 43.2637Z",
    fill: "#0D6E9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3521 39.3499H62.0801C61.8132 39.3499 61.5972 39.1335 61.5972 38.8669C61.5972 38.6003 61.8132 38.384 62.0801 38.384H63.3521C63.6187 38.384 63.835 38.6003 63.835 38.8669C63.835 39.1335 63.6187 39.3499 63.3521 39.3499Z",
    fill: "#0D6E9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8027 35.436H62.0801C61.8132 35.436 61.5972 35.2197 61.5972 34.9531C61.5972 34.6865 61.8132 34.4702 62.0801 34.4702H63.8027C64.0696 34.4702 64.2856 34.6865 64.2856 34.9531C64.2856 35.2197 64.0696 35.436 63.8027 35.436Z",
    fill: "#0D6E9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8027 51.0913H62.0801C61.8132 51.0913 61.5972 50.875 61.5972 50.6084C61.5972 50.3416 61.8132 50.1255 62.0801 50.1255H63.8027C64.0696 50.1255 64.2856 50.3416 64.2856 50.6084C64.2856 50.875 64.0696 51.0913 63.8027 51.0913Z",
    fill: "#0D6E9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3521 47.1775H62.0801C61.8132 47.1775 61.5972 46.9612 61.5972 46.6946C61.5972 46.428 61.8132 46.2117 62.0801 46.2117H63.3521C63.6187 46.2117 63.835 46.428 63.835 46.6946C63.835 46.9612 63.6187 47.1775 63.3521 47.1775Z",
    fill: "#0D6E9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2466 52.7446V38.8669H53.9849V52.7446C53.9849 52.7446 56.2395 53.7908 56.2395 57.1182C56.2395 58.9683 55.1577 60.5703 53.5935 61.3252C54.2056 61.6206 54.8916 61.7861 55.6155 61.7861C58.1895 61.7861 60.2837 59.6921 60.2837 57.1182C60.2837 55.1636 59.0688 53.4236 57.2466 52.7446Z",
    fill: "#F2C94C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -4,
    y: 0,
    width: 78,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(36 32)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmokeHeat);
export default __webpack_public_path__ + "static/media/smoke-heat.c8365d55af657c616d2327ea30e3e256.svg";
export { ForwardRef as ReactComponent };